export const REFRESH_USER_COUNT = 'REFRESH_USER_COUNT';

import { get, put, post, destroy, upload } from 'utils/fetchRequest';

export const uploadImage = async (data) => {
    try {
        const result = await upload('files/link', data);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const getLinkList = async (searchText) => {
    try {
        const result = await get(`link${searchText ? `?search=${searchText}` : ''}`);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const getLinkContent = async (newsId) => {
    try {
        const result = await get(`link/${newsId}`);
        return result;
    } catch (err) {
        return { error: err };
    }
};

export const createLink = async (data) => {
    try {
        const result = await post('link', data);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const updateLink = async (id, data) => {
    try {
        const result = await put(`link/${id}`, data);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const deleteLink = async (id) => {
    try {
        const result = await destroy(`link/${id}`);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const setSpecial = async (id, data) => {
    try {
        const result = await put(`link/special/${id}`, data);

        return result;
    } catch (err) {
        return { error: err };
    }
};

// export const subscribeUser = async (id) => {
//     try {
//         const result = await put(`payment/admin/${id}`);

//         return result;
//     } catch (err) {
//         return { error: err };
//     }
// };

// export const getUserCount = async () => {
//     try {
//         const result = await get(`users/count`);

//         return result;
//     } catch (err) {
//         return { error: err };
//     }
// };
